import { useCallback } from 'react';
import styled from 'styled-components';
import { Chip } from '@mui/material';

const StyledChip = styled(Chip)<{ $selected?: boolean }>`
  padding: 4px 12px;
  margin-right: 8px;
  color: ${({ theme, $selected }) =>
    $selected ? theme.palette.common.white : theme.palette.common.black};
  background-color: ${({ theme, $selected }) =>
    $selected ? theme.palette.common.black : theme.palette.common.white};

  :hover {
    background-color: ${({ theme, $selected }) =>
      $selected ? theme.palette.common.black : theme.palette.common.gray6};
  }
`;

type Props = {
  label: React.ReactNode;
  value: string;
  filter: string;
  onClick?: (v: string) => void;
  disabled?: boolean;
};

const QuickFilterChip = ({
  label,
  value,
  filter,
  onClick,
  disabled,
}: Props) => {
  const handleClick = useCallback(() => onClick?.(value), [value, onClick]);

  return (
    <StyledChip
      label={label}
      onClick={handleClick}
      variant={filter === value ? 'filled' : 'outlined'}
      $selected={filter === value}
      size="small"
      disabled={disabled}
    />
  );
};

export default QuickFilterChip;
